import { render, staticRenderFns } from "./PositionTrattoreBox.vue?vue&type=template&id=0a197b92&scoped=true"
import script from "./PositionTrattoreBox.vue?vue&type=script&lang=js"
export * from "./PositionTrattoreBox.vue?vue&type=script&lang=js"
import style0 from "./PositionTrattoreBox.vue?vue&type=style&index=0&id=0a197b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a197b92",
  null
  
)

export default component.exports